// Settings Page Web Component - Index/List View
import { renderEmojiBadge, renderPageTitle } from '../utils/emoji-badge.js';

class SettingsPage extends HTMLElement {
  connectedCallback() {
    this.render();
    this.attachEventListeners();
  }

  render() {
    this.innerHTML = `
      <div class="settings-page">
        <div class="settings-header">
          ${renderPageTitle('⚙️', 'Settings', 'h1')}
          <p>Manage your account preferences and security settings</p>
        </div>

        <div class="settings-list">
          <a href="/settings/security" class="settings-item" data-route="/settings/security">
            ${renderEmojiBadge('🔒', 'md')}
            <div class="item-content">
              <span class="item-title">Security</span>
              <span class="item-description">Set up 2FA and reset your password</span>
            </div>
            <span class="item-arrow">→</span>
          </a>
          
          <a href="/settings/notifications" class="settings-item" data-route="/settings/notifications">
            ${renderEmojiBadge('🔔', 'md')}
            <div class="item-content">
              <span class="item-title">Notifications</span>
              <span class="item-description">Choose how you want to be notified</span>
            </div>
            <span class="item-arrow">→</span>
          </a>
          
          <a href="/settings/sparkle-sources" class="settings-item" data-route="/settings/sparkle-sources">
            ${renderEmojiBadge('✨', 'md')}
            <div class="item-content">
              <span class="item-title">Sparkle Sources</span>
              <span class="item-description">Connect cloud storage accounts</span>
            </div>
            <span class="item-arrow">→</span>
          </a>
          
          <a href="/settings/facebook-import-friends" class="settings-item" data-route="/settings/facebook-import-friends">
            ${renderEmojiBadge('👥', 'md')}
            <div class="item-content">
              <span class="item-title">Import Facebook Friends</span>
              <span class="item-description">Import your Facebook friends list</span>
            </div>
            <span class="item-arrow">→</span>
          </a>
          
          <a href="/settings/facebook-import-posts" class="settings-item" data-route="/settings/facebook-import-posts">
            ${renderEmojiBadge('📝', 'md')}
            <div class="item-content">
              <span class="item-title">Import Facebook Posts</span>
              <span class="item-description">Import your Facebook posts, comments, photos, and videos</span>
            </div>
            <span class="item-arrow">→</span>
          </a>
          
          <a href="/settings/imported-friends" class="settings-item" data-route="/settings/imported-friends">
            ${renderEmojiBadge('👥', 'md')}
            <div class="item-content">
              <span class="item-title">Imported Friends</span>
              <span class="item-description">Manage friends from Facebook import</span>
            </div>
            <span class="item-arrow">→</span>
          </a>
          
          <a href="/settings/rss-feeds" class="settings-item" data-route="/settings/rss-feeds">
            ${renderEmojiBadge('📡', 'md')}
            <div class="item-content">
              <span class="item-title">RSS Feeds</span>
              <span class="item-description">Import posts from your own blog via RSS</span>
            </div>
            <span class="item-arrow">→</span>
          </a>

          <a href="/settings/widgets" class="settings-item" data-route="/settings/widgets" id="widgetsSettingsItem">
            ${renderEmojiBadge('🧩', 'md')}
            <div class="item-content">
              <span class="item-title">My Widgets</span>
              <span class="item-description">Create profile widgets for your layout</span>
            </div>
            <span class="item-arrow">→</span>
          </a>
        </div>
      </div>
    `;
  }

  attachEventListeners() {
    // Navigation is handled by the router via href links
    // No additional listeners needed
  }
}

// Register the custom element
customElements.define('settings-page', SettingsPage);
